import { defineMessages } from 'react-intl';

type Validator = {
  value: {
    'content-type': string | undefined;
    encoding: string | undefined;
    data: string | undefined;
  };
  field: Record<string, any>;
  formData: any;
  formatMessage: Function;
};

export const isCharNumberValid = (props: Validator) => {
  const { value, formatMessage, field } = props;

  const htmlCharCounter = value?.data?.length;
  const isValid =
    htmlCharCounter <= field.widgetOptions.frontendOptions.widgetProps.max_char;
  return isValid
    ? null
    : formatMessage(messages.char_length_error, { field: field.title });
};

const messages = defineMessages({
  char_length_error: {
    id: 'char_length_error',
    defaultMessage:
      'Il testo supera la lunghezza consentita per il campo {field}.',
  },
});
